import { Flex, Radio, RadioGroup, RadioProps, Stack, Text } from '@chakra-ui/react'
import { useField } from 'formik'
import { capitalize } from 'lodash'
import * as React from 'react'
import { OptionType } from 'utils'
import { LabelProps } from '../styles'

export type ConnectedRadioArrayProps = LabelProps &
  RadioProps & {
    name: string
    labelStyle?: RadioProps
    options: OptionType[]
    showError?: boolean
    radioSize?: 'xs' | 'sm' | 'md' | 'lg'
    direction?: 'row' | 'column'
  }

const ConnectedRadioArray: React.FC<ConnectedRadioArrayProps> = ({
  options,
  labelStyle,
  showError,
  radioSize = 'md',
  direction = 'column',
  ...rest
}) => {
  const [field, meta, helpers] = useField(rest.name)

  const isInvalid = meta.touched && meta.error

  return (
    <Flex
      mb={rest.mb}
      ml={rest.ml}
      mr={rest.mr}
      mt={rest.mt}
      width="100%"
      align="center"
      justify={rest.justifyContent}
    >
      <Flex alignItems="flex-start" flexDirection="column" width="100%">
        <RadioGroup value={field.value || ''} onChange={(value) => helpers.setValue(value)}>
          <Stack direction={direction}>
            {options.map((el) => (
              <Radio
                key={el.value}
                value={el.value}
                borderColor={isInvalid ? 'error.500' : 'text'}
                size={radioSize}
                fontWeight="black"
                color="text"
                {...labelStyle}
              >
                {capitalize(el.label)}
              </Radio>
            ))}
          </Stack>
        </RadioGroup>
        {isInvalid && showError ? (
          <Text fontWeight="bold" color="error.500" mt={2}>
            {meta.error}
          </Text>
        ) : null}
      </Flex>
    </Flex>
  )
}

export default ConnectedRadioArray

ConnectedRadioArray.defaultProps = {
  mb: 2,
  alignItems: 'center',
  justifyContent: 'flex-start'
}
